import { IDB_rowRead, IDB_rowsDelete, IDB_rowsReadAll, IDB_rowsWrite } from './IDB.queries'
import { IDB_globalDb } from './IDB'
import type { Loca_IOwnership } from '../Loca/Loca.ownership'

export function IDB_locationOwnershipRead(locationOwnershipId: number) {
    return IDB_rowRead<Loca_IOwnership>(IDB_globalDb, 'location_ownerships', locationOwnershipId)
}

export function IDB_locationOwnershipsDelete(locationOwnershipId: number[]) {
    return IDB_rowsDelete(IDB_globalDb, 'location_ownerships', locationOwnershipId)
}

export function IDB_locationOwnershipsReadAll() {
    return IDB_rowsReadAll<Loca_IOwnership>(IDB_globalDb, 'location_ownerships')
}

export function IDB_locationOwnershipsWrite(locationOwnerships: Loca_IOwnership[]) {
    return IDB_rowsWrite(IDB_globalDb, 'location_ownerships', locationOwnerships)
}
